import { render, staticRenderFns } from "./PredictionSummaryTable.vue?vue&type=template&id=b7fce5f4&scoped=true&"
import script from "./PredictionSummaryTable.vue?vue&type=script&lang=js&"
export * from "./PredictionSummaryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7fce5f4",
  null
  
)

export default component.exports